import React, { Component } from 'react';
import { connect } from 'react-redux';
import RCSlider from 'rc-slider';

import throttle from '../../../../util/throttle';

import { handleError, saveConfig, updateTRCScale } from '../../FilterActions';

const createSliderWithTooltip = RCSlider.createSliderWithTooltip;
const Slider = createSliderWithTooltip(RCSlider);

class ScaleSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scale: 1,
      step: 0.1,
      min: 0.1,
      max: 2,
    };

    this.saveChanges = throttle(this._saveChanges, 1000, this);
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.scale !== this.props.scale) {
      this.updateState();
    }
  }

  updateState() {
    this.setState({
      scale: this.props.scale,
    });
  }

  decrease = () => {
    let value = this.state.scale - this.state.step;
    if (value < this.state.min) {
      return false;
    }

    this.setState({ scale: value });
    this.handleScaleAfterChange(value);
  };

  increase = () => {
    let value = this.state.scale + this.state.step;
    if (value > this.state.max) {
      return false;
    }

    this.setState({ scale: value });
    this.handleScaleAfterChange(value);
  };

  handleScaleChange = (e) => {
    this.setState({ scale: e });
  };

  handleScaleAfterChange = (e) => {
    this.props.updateTRCScale(e, this.props.chart);
    this.props.saveConfig();
  };

  render() {
    return (
      <div className="data-slider" style={{ padding: '20px 15px 20px 40px' }}>
        <div className="data-slider-container">
          <button
            className="btn btn-default btn-white-shadow"
            disabled={this.state.scale === this.state.min}
            onClick={this.decrease}
          >
            <i className="fa fa-solid fa-caret-left glyphicon glyphicon-chevron-left"></i>
          </button>
          <Slider
            min={this.state.min}
            max={this.state.max}
            step={this.state.step}
            value={this.state.scale}
            onChange={this.handleScaleChange}
            onAfterChange={this.handleScaleAfterChange}
            tipFormatter={(value) => `${value}`}
            tipProps={{ visible: true }}
          />          
          <button
            className="btn btn-default btn-white-shadow"
            disabled={this.state.scale === this.state.max}
            onClick={this.increase}
          >
            <i className="fa fa-solid fa-caret-right glyphicon glyphicon-chevron-right"></i>
          </button>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleError: (err) => dispatch(handleError(err, { log: false })),
    saveConfig: () => dispatch(saveConfig()),
    updateTRCScale: (val, chart) => dispatch(updateTRCScale(val, chart)),
  };
};

const mapStateToProps = (state) => {
  let chart = state.filters.chart;
  return {
    chart: state.filters.chart,
    scale: state.filters[chart].scale,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(ScaleSlider);
export { connected as ScaleSlider };
